'use strict';

var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Validation = require('utils/validation');

var AbstractWizardView = OOP.extend(
    Marionette.LayoutView,
    {
        backgroundTasks: Misc.getBackgroundTaskManager(),
        selected: 1,
        events: function () {
            var events = {
                'click button.js-wizard-next': 'doWizardNext',
                'click button.js-wizard-prev': 'doWizardPrev',
                'click button.js-wizard-done': 'doWizardDone',
            };

            _.extend(events, this.getWizardEvents() || {});
            return events;
        },
        getWizardEvents: function () {
            return undefined;
        },

        initialize: function (options) {
            this.wizardPermCtx = {};
            this.wizardConfig = {};
            this.base.initialize(options);
        },

        getWizardContext: function () {
            var buttons = this.getWizardButtons();
            var names = this.getTabNames();

            var buttonState = {
                prev: this.canWizardChange(this.selected - 1, this.selected),
                next: this.canWizardChange(this.selected + 1, this.selected),
                done: this.canWizardFinish(),
            };

            this.wizardConfig.prevButtonState = this.wizardConfig.buttonState;
            this.wizardConfig.buttonState = buttonState;

            this.currentWizardContext = {
                buttonState: buttonState,
                permCtx: this.wizardPermCtx,
                selected: this.selected,
                tabNames: names,
                selectedName: '',
                buttons: _.compact([
                    buttons.cancel
                        ? {
                              id: buttons.cancel.id || 'ct-wizard-cancel',
                              title: buttons.cancel.title,
                              isCancel: true,
                              type: 'cancel',
                          }
                        : undefined,
                    buttons.prev
                        ? {
                              id: buttons.prev.id || 'ct-wizard-prev',
                              title: buttons.prev.title,
                              disabled: !buttonState.prev,
                              arrowLeft: true,
                              class: buttons.prev.class || 'js-wizard-prev',
                              type: 'prev',
                          }
                        : undefined,
                    buttons.next
                        ? {
                              id: buttons.next.id || 'ct-wizard-next',
                              title: buttons.next.title,
                              disabled: !buttonState.next,
                              arrowRight: true,
                              class: buttons.next.class || 'js-wizard-next',
                              type: 'next',
                          }
                        : undefined,
                    buttons.done
                        ? {
                              id: buttons.done.id || 'ct-wizard-done',
                              title: buttons.done.title,
                              disabled: !buttonState.done,
                              class: buttons.done.class || 'js-wizard-done',
                              isPrimary: true,
                              type: 'done',
                          }
                        : undefined,
                ]),
                tabCount: this.currentWizardContext && this.currentWizardContext.tabCount,
                tabsHidden: {},
            };

            if (this.wizardConfig.prevButtonState === undefined || this.isButtonStateChanged()) {
                if (this.wizardConfig.onUpdateButtons) {
                    this.wizardConfig.onUpdateButtons.apply(this, [
                        this.wizardConfig.prevButtonState,
                        this.wizardConfig.buttonState,
                    ]);
                }
            }

            return this.currentWizardContext;
        },

        isButtonStateChanged: function () {
            var p = this.wizardConfig.prevButtonState || {};
            var n = this.wizardConfig.buttonState || {};

            return !p.prev != !n.prev || !p.next != !n.next || !p.done != !n.done;
        },

        canWizardChange: function (is, was) {
            var maxTabCount = this.wizardPermCtx.tabCount || this.selected + 1;
            return is >= 1 && is <= maxTabCount;
        },

        canWizardFinish: function () {
            return true;
        },

        getTabNames: function () {
            return {};
        },

        serializeData: function () {
            var ctx = this.getWizardContext();
            return { _wizardContext: ctx };
        },

        getWizardButtons: function () {
            return {
                prev: { title: i18n.TR('Zurück') },
                next: { title: i18n.TR('Weiter') },
                cancel: { title: i18n.TR('Abbrechen') },
                done: { title: i18n.TR('Speichern') },
            };
        },

        onShow: function () {
            var self = this;
            this.onGotoPage(this.selected);
            this.on('render', function () {
                self.updateWizardButtons();
            });
        },

        onGotoPage: function (page, prevPage) {},

        prepareMove: function (doneFct, nextPage) {
            doneFct();
        },

        doStep: function (doneFct, nextPage) {
            var self = this;
            this.prepareMove(function () {
                self.backgroundTasks.done(function () {
                    doneFct.apply(self);
                });
            }, nextPage);
        },

        canMoveNext: function () {
            return this.canWizardChange(this.selected + 1, this.selected);
        },

        doChangePage: function (newPage, forceRender) {
            if (newPage == this.selected || this.canWizardChange(newPage, this.selected)) {
                var needRender = forceRender || newPage != this.selected;
                var previousPage = this.selected;
                this.selected = newPage;
                if (needRender) this.render();
                this.onGotoPage(this.selected, previousPage);
            }
        },

        tryWizardNext: function () {
            var canChange = this.canWizardChange(this.selected + 1, this.selected);
            if (canChange) {
                this.doWizardNext();
            }
        },

        doWizardNext: function () {
            this.doStep(function () {
                this.doChangePage(this.selected + 1);
            }, this.selected + 1);
        },

        doWizardPrev: function () {
            this.doStep(function () {
                this.doChangePage(this.selected - 1);
            }, this.selected - 1);
        },

        doWizardDone: function () {
            this.doStep(function () {
                this.wizardDone();
            });
        },

        changePage: function (newPage, forceRender) {
            this.doStep(function () {
                this.doChangePage(newPage, forceRender);
            });
        },

        wizardDone: function () {},

        updateWizardButtons: function () {
            var self = this;
            var fcts = {
                prev: function () {
                    return self.canWizardChange(self.selected - 1, self.selected);
                },
                next: function () {
                    return self.canWizardChange(self.selected + 1, self.selected);
                },
                done: function () {
                    return self.canWizardFinish();
                },
            };

            var buttons = this.getWizardContext().buttons;
            _.each(buttons, function (btnInfo) {
                var fct = fcts[btnInfo.type];
                if (!fct) return;

                var isDisabled = !fct();
                var btn = self.$el.find('#' + btnInfo.id);
                if (isDisabled) btn.addClass('disabled');
                else btn.removeClass('disabled');
                btn.prop('disabled', isDisabled);
            });
        },

        wizardValidate: function (fct) {
            return Validation.validate(
                this,
                fct,
                function (name, ctrl, message, contextData) {
                    if (contextData.page) {
                        this.doStep(function () {
                            this.doChangePage(contextData.page);
                        });
                    }
                },
                true
            );
        },

        setError: function (errData) {
            this.errors = Misc.getErrors(errData);
        },
    },
    'AbstractWizardView'
);

module.exports = AbstractWizardView;
